<div class="body" [class.entity-not-supported]="!entityIsSupported">

    <ng-container *ngIf="entityIsSupported; else unsupportedEntity">

        <div *ngIf="!(service.checkingVersion$|async); else loading" matTooltip="Letzte Überprüfung: vor {{secondsAgo}}s, Ergebnis: {{(isValid$|async)? 'Keine Änderungen auf dem Server': 'Achtung! Serverzustand abweichend!'}}">

            <mat-icon class="icon" [ngClass]="{
                'danger': !(isValid$|async),
                'success': (isValid$|async)
            }">{{(isValid$|async)? 'done': 'clear'}}</mat-icon>

        </div>

    </ng-container>

</div>

<ng-template #unsupportedEntity>

    <mat-icon class="icon unsupported-entity" matTooltip="Dieser Typ verfügt momentan über keine Versionierung">block</mat-icon>

</ng-template>

<ng-template #loading>

    <mat-spinner diameter="50"></mat-spinner>

</ng-template>